import { render, staticRenderFns } from "./ModelEdit.vue?vue&type=template&id=64f044fe"
import script from "./ModelEdit.vue?vue&type=script&lang=js"
export * from "./ModelEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports